var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { ListSubheader as MuiListSubheader } from '@mui/material';
import { Typography } from '../../components/Typography';
export var ListSubheader = styled(MuiListSubheader)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 14px 24px 14px 16px;\n"], ["\n  padding: 14px 24px 14px 16px;\n"])));
export var GroupTitle = styled(Typography).attrs({ variant: 'subtitle3' })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var typographyAndIcons = _a.theme.custom.lightTheme.colors.typographyAndIcons;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), typographyAndIcons.default.disabled);
});
var templateObject_1, templateObject_2, templateObject_3;
